<template>
  <div class="promotionPage page">
    <div class="container">
      <search-template
        :brand-id="brand.id"
        :search-title="brand.name"
        current-breadcrumb="Marka"
        list-name="Brand list"
        route-name="brand-slug"
        route-pagination-name="brand-page-number"
        :seo-info="`<p>${brand.description}</p>`"
        :seo-description-down="brand.seoDescriptionDown"
        :seo-description-up="brand.seoDescriptionUp"
      />
    </div>
    <LazyHydrate :when-visible="{ rootMargin: '100px' }">
      <newsletter-home white />
    </LazyHydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import { mapState, mapMutations } from 'vuex';
import SearchTemplate from '~/components/SearchTemplate';

export default {
  name: 'BrandPage',
  components: {
    LazyHydrate,
    SearchTemplate,
    NewsletterHome: () => import('~/components/Newsletter/NewsletterHome'),
  },
  nuxtI18n: {
    paths: {
      pl: '/marka/:slug',
      en: '/brand/:slug',
    },
  },
  async asyncData({ $config, error, $axios, route }) {
    try {
      const { data } = await $axios.get(
        `${$config.baseOfixApi}/e-commerce/v1/brands/${route.params.slug}`,
        {
          useCache: true,
        },
      );
      return {
        seo: data.seo,
        brand: data.brand,
      };
    } catch (e) {
      error({
        statusCode: 404,
        message: e.response.data.message ? e.response.data.message : 'Brand not found',
      });
    }
  },
  head() {
    return {
      title: `${this.seo.title}`,
      meta: this.$helper.metaDescription([
        ...(Object.keys(this.$route.query).length
          ? [
              {
                name: 'robots',
                content: 'noindex, nofollow',
              },
            ]
          : [
              {
                name: 'robots',
                content: 'index, follow',
              },
            ]),
        ...this.seo.metaTags,
      ]),
      script: [...this.$helper.schemaData(this.seo.schemaOrgData)],
      link: this.$helper.prevNextUrl(
        this.$route.query,
        this.pagination.offset,
        this.pagination.limit,
        this.pagination.countTotal,
        'brand-slug',
        'brand-page-number',
      ),
    };
  },
  computed: {
    ...mapState({
      pagination: state => state.productsFilters.search.pagination,
    }),
  },
  destroyed() {
    this.setBrandId({ type: 'search', value: null });
  },
  methods: {
    ...mapMutations({
      setBrandId: 'productsFilters/setBrandId',
    }),
  },
};
</script>
